import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useCallback, useMemo } from 'react'
import AppStore from '@v4/store/appStore'

const usePopupButton = variant => {
	const sectionId = PageBuilderSelector.usePopupSectionId(variant)
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const { setActiveSectionId } = PageBuilderSelector.useActions()

	const handleClick = useCallback(
		event => {
			if (isBuilderMode) {
				return
			}
			event.preventDefault()
			event.stopPropagation()
			setActiveSectionId({ id: sectionId })
		},
		[isBuilderMode, setActiveSectionId, sectionId],
	)

	return useMemo(
		() => ({
			handleClick,
		}),
		[handleClick],
	)
}

export default usePopupButton
